import { Component, OnInit } from '@angular/core';
import { ErrorModel } from 'src/app/shared/models/error.model';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

import { OpEnum } from '../../../shared/enums/op.enum';
import { TypeContractModel } from '../../../shared/models/abre-cuentas.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
// import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-employed-contract',
  templateUrl: './employed-contract.component.html',
  styleUrls: ['./employed-contract.component.scss'],
})
export class EmployedContractComponent implements OnInit {

  typeContracts: TypeContractModel[] = [];
  employedModel: any;
  contract?: TypeContractModel;
  // reactiveErrorDate = '';
  // msg: string;
  radioCheck = false;
  // timeMin: any;
  // errorInfo: ErrorModel;
  // timeText: string;
  // beforeDate: string;
  has_second_headline: any;
  formGroup: FormGroup;
  // maxDate: string;

  /**
   * Creates an instance of EmployedContractComponent.
   * @param {NavigationService} navigationService
   * @param {AbreCuentasService} abreCuentasService
   * @param {ParametersService} parametersService
   * @memberof EmployedContractComponent
   */
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    // private helpersService: HelpersService,
    private navigationService: NavigationService,
    private formBuilder: FormBuilder,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService) {
    this.headerService.show(true, true, true);
  }

  /**
   * init component
   *
   * @memberof EmployedContractComponent
   */
  ngOnInit() {
    // this.timeMin = 3;
    this.formGroup = this.formBuilder.group({
      typeContract: ['', [Validators.required]],
      contractDate: ['', [Validators.required]],
    });
    this.has_second_headline = this.abreCuentasService.getSecondHeadline();
    const occupationTime = this.parametersService.getSetting(OpEnum.OCUPATION_TIME_TC);
    const selectedEmploy = occupationTime ? occupationTime['list_dependent_time'] : this.abreCuentasService.getListTypeContract();
    this.employedModel = (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
    this.abreCuentasService.getEmployedContractModel() : this.abreCuentasService.getEmployedContractSecondHeadlineModel();
    if (this.employedModel && this.employedModel.typeContract) {
      this.formGroup.setValue({ ...this.employedModel });
      // this.timeMin = this.employedModel.typeContract.timeMin;
      this.typeContracts = selectedEmploy.map(data => ({
        ...data,
        checked: data.elementId === this.employedModel.typeContract.elementId,
      }));

      if (this.abreCuentasService.getFlowLoan() && this.abreCuentasService.getOccupationSelected().id === 1) {
        this.typeContracts = this.parametersService.getSetting(OpEnum.LIST_TYPE_CONTRACT_LOAN);
      }

      this.radioButtonChange({ value: this.employedModel.typeContract });
    } else if (this.employedModel && !this.employedModel.contractDate) {
      this.typeContracts = selectedEmploy.map(data => ({ ...data, checked: false }));
    } else {
      this.typeContracts = selectedEmploy;
    }
  }

  /**
   * Check date input and redirect to next secuence
   *
   * @memberof EmployedContractComponent
   */
  next() {
    // const date = this.formGroup.value.contractDate;
    // const actual = (new Date()).toLocaleDateString();
    // const resultDate = this.helpersService.compareDates(actual, date);
    const contract = this.typeContracts.find(data => data.checked);
    if (!contract) {
      return;
    }

    this.employedModel = { ...this.formGroup.value };
    (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline) ?
      this.abreCuentasService.setEmployedContractModel(this.employedModel) :
      this.abreCuentasService.setEmployedContractSecondHeadlineModel(this.employedModel);

    // const timeMinDays = Math.floor(this.timeMin * (365.25 / 12));
    // if (resultDate >= timeMinDays) {
    this.navigationService.nextStep('200');
      // return;
    // }

    // this.errorInfo = {
    //   title: '¡Menos de ' + this.timeText + ' no es suficiente!',
    //   description: 'Edita la fecha que ingresaste o intenta nuevamente cuando lleves ' + this.timeText + ' realizando tu actividad',
    //   buttonLabel: this.copyService.copies.error_back_to_edit_date_end,
    //   type: 'date',
    //   buttonAction: '$exit',
    // };
    // this.abreCuentasService.setErrorProperty(this.errorInfo);
    // this.navigationService.pageLoadTag('ErrorRechazoContrato', ['pv232', '', '', '']);
    // this.navigationService.nextStep('502');

  }

  /**
   * check contrato selected
   *
   * @param {*} tipoContrato
   * @memberof EmployedContractComponent
   */
  selectContract() {
    this.contract = this.typeContracts.find(data => data.checked);
    if (!this.contract) {
      return;
    }

    this.formGroup.controls.typeContract.setValue(this.contract);
    // this.msg = this.contract.message;
    // this.timeMin = this.contract.timeMin;
    // this.timeText = this.contract.timeText;
    this.radioCheck = this.contract.checked;
  }

  radioButtonChange(event) {
    this.typeContracts = this.typeContracts.map(data => ({ ...data, checked: data.elementId === event.value.elementId }));
    this.selectContract();
  }
}
